export class ListGcpNetworksResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networks",
            "baseName": "networks",
            "type": "Array<ListGcpNetworksResponseNetworksInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGcpNetworksResponse.attributeTypeMap;
    }
    constructor() {
    }
}
